/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "dymensionxyz.dymension.rollapp";

export interface RollappMetadata {
  /** website is the rollapp website */
  website: string;
  /** description is the rollapp description. should be limited to 512 chars */
  description: string;
  /** logo_url is the rollapp logo url */
  logoUrl: string;
  /** telegram is the rollapp telegram link */
  telegram: string;
  /** x is the rollapp twitter link */
  x: string;
  /** genesis_url has the genesis file */
  genesisUrl: string;
  /** display_name is a non semantic name for displaying on gui etc. Size limited. */
  displayName: string;
  /** tagline is a non semantic tagline/catch-phrase. Size limited. */
  tagline: string;
  /** explorer_url is the rollapp's block explorer link */
  explorerUrl: string;
  /** fee_denom is the base denom for fees */
  feeDenom:
    | DenomMetadata
    | undefined;
  /** Tags is a list of tags that can be used to filter rollapps. */
  tags: string[];
}

export interface DenomMetadata {
  display: string;
  base: string;
  exponent: number;
}

function createBaseRollappMetadata(): RollappMetadata {
  return {
    website: "",
    description: "",
    logoUrl: "",
    telegram: "",
    x: "",
    genesisUrl: "",
    displayName: "",
    tagline: "",
    explorerUrl: "",
    feeDenom: undefined,
    tags: [],
  };
}

export const RollappMetadata = {
  encode(message: RollappMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.website !== "") {
      writer.uint32(10).string(message.website);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.logoUrl !== "") {
      writer.uint32(26).string(message.logoUrl);
    }
    if (message.telegram !== "") {
      writer.uint32(34).string(message.telegram);
    }
    if (message.x !== "") {
      writer.uint32(42).string(message.x);
    }
    if (message.genesisUrl !== "") {
      writer.uint32(50).string(message.genesisUrl);
    }
    if (message.displayName !== "") {
      writer.uint32(58).string(message.displayName);
    }
    if (message.tagline !== "") {
      writer.uint32(66).string(message.tagline);
    }
    if (message.explorerUrl !== "") {
      writer.uint32(74).string(message.explorerUrl);
    }
    if (message.feeDenom !== undefined) {
      DenomMetadata.encode(message.feeDenom, writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.tags) {
      writer.uint32(90).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RollappMetadata {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRollappMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.website = reader.string();
          break;
        case 2:
          message.description = reader.string();
          break;
        case 3:
          message.logoUrl = reader.string();
          break;
        case 4:
          message.telegram = reader.string();
          break;
        case 5:
          message.x = reader.string();
          break;
        case 6:
          message.genesisUrl = reader.string();
          break;
        case 7:
          message.displayName = reader.string();
          break;
        case 8:
          message.tagline = reader.string();
          break;
        case 9:
          message.explorerUrl = reader.string();
          break;
        case 10:
          message.feeDenom = DenomMetadata.decode(reader, reader.uint32());
          break;
        case 11:
          message.tags.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RollappMetadata {
    return {
      website: isSet(object.website) ? String(object.website) : "",
      description: isSet(object.description) ? String(object.description) : "",
      logoUrl: isSet(object.logoUrl) ? String(object.logoUrl) : "",
      telegram: isSet(object.telegram) ? String(object.telegram) : "",
      x: isSet(object.x) ? String(object.x) : "",
      genesisUrl: isSet(object.genesisUrl) ? String(object.genesisUrl) : "",
      displayName: isSet(object.displayName) ? String(object.displayName) : "",
      tagline: isSet(object.tagline) ? String(object.tagline) : "",
      explorerUrl: isSet(object.explorerUrl) ? String(object.explorerUrl) : "",
      feeDenom: isSet(object.feeDenom) ? DenomMetadata.fromJSON(object.feeDenom) : undefined,
      tags: Array.isArray(object?.tags) ? object.tags.map((e: any) => String(e)) : [],
    };
  },

  toJSON(message: RollappMetadata): unknown {
    const obj: any = {};
    message.website !== undefined && (obj.website = message.website);
    message.description !== undefined && (obj.description = message.description);
    message.logoUrl !== undefined && (obj.logoUrl = message.logoUrl);
    message.telegram !== undefined && (obj.telegram = message.telegram);
    message.x !== undefined && (obj.x = message.x);
    message.genesisUrl !== undefined && (obj.genesisUrl = message.genesisUrl);
    message.displayName !== undefined && (obj.displayName = message.displayName);
    message.tagline !== undefined && (obj.tagline = message.tagline);
    message.explorerUrl !== undefined && (obj.explorerUrl = message.explorerUrl);
    message.feeDenom !== undefined
      && (obj.feeDenom = message.feeDenom ? DenomMetadata.toJSON(message.feeDenom) : undefined);
    if (message.tags) {
      obj.tags = message.tags.map((e) => e);
    } else {
      obj.tags = [];
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<RollappMetadata>, I>>(object: I): RollappMetadata {
    const message = createBaseRollappMetadata();
    message.website = object.website ?? "";
    message.description = object.description ?? "";
    message.logoUrl = object.logoUrl ?? "";
    message.telegram = object.telegram ?? "";
    message.x = object.x ?? "";
    message.genesisUrl = object.genesisUrl ?? "";
    message.displayName = object.displayName ?? "";
    message.tagline = object.tagline ?? "";
    message.explorerUrl = object.explorerUrl ?? "";
    message.feeDenom = (object.feeDenom !== undefined && object.feeDenom !== null)
      ? DenomMetadata.fromPartial(object.feeDenom)
      : undefined;
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseDenomMetadata(): DenomMetadata {
  return { display: "", base: "", exponent: 0 };
}

export const DenomMetadata = {
  encode(message: DenomMetadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.display !== "") {
      writer.uint32(10).string(message.display);
    }
    if (message.base !== "") {
      writer.uint32(18).string(message.base);
    }
    if (message.exponent !== 0) {
      writer.uint32(24).uint32(message.exponent);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DenomMetadata {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDenomMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.display = reader.string();
          break;
        case 2:
          message.base = reader.string();
          break;
        case 3:
          message.exponent = reader.uint32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DenomMetadata {
    return {
      display: isSet(object.display) ? String(object.display) : "",
      base: isSet(object.base) ? String(object.base) : "",
      exponent: isSet(object.exponent) ? Number(object.exponent) : 0,
    };
  },

  toJSON(message: DenomMetadata): unknown {
    const obj: any = {};
    message.display !== undefined && (obj.display = message.display);
    message.base !== undefined && (obj.base = message.base);
    message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<DenomMetadata>, I>>(object: I): DenomMetadata {
    const message = createBaseDenomMetadata();
    message.display = object.display ?? "";
    message.base = object.base ?? "";
    message.exponent = object.exponent ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
